import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { WeekPipe } from '@core/pipes/week.pipe';

@Component({
  selector: 'date-time',
  templateUrl: './date-time.component.html',
  styleUrls: ['./date-time.component.scss']
})
export class DateTimeComponent {

  @Input()
  public value!: Date | number

  @Input()
  public mode: 'date-time' | 'time-date' | 'date-week' | 'date' | 'time' = 'date-time';

  public get first(): string {
    switch (this.mode) {
      case 'date-time': return this.date.transform(this.value, 'dd-MM-yy');
      case 'date-week': return this.date.transform(this.value, 'dd-MM');
      case 'time-date': return this.date.transform(this.value, 'HH:mm:ss');
      case 'date': return this.date.transform(this.value, 'dd-MM-yy');
      case 'time': return this.date.transform(this.value, 'HH:mm:ss');
      default: return this.date.transform(this.value, 'dd-MM-yy');
    }
  }

  public get second(): string | undefined {
    switch (this.mode) {
      case 'date-time': return this.date.transform(this.value, 'HH:mm:ss');
      case 'date-week': return this.date.transform(this.value, 'yyyy');
      case 'time-date': return this.date.transform(this.value, 'dd-MM-yyyy');
      case 'date': return undefined;
      case 'time': return undefined;
      default: return this.date.transform(this.value, 'HH:mm:ss');
    }
  }

  public get dow(): string {
    return WeekPipe.transform(this.value, 'short');
  }

  public get weekend(): boolean {

    let date = typeof this.value == 'number' ? new Date(this.value) : this.value as Date;
    return [0, 6].contains(date.getDay());
  }

  constructor(private date: DatePipe) { }
}
